import React from "react";
import { Section, SectionHeading } from "./Section";
import { painPoints } from "../data/landing";
export function PainPoints() {
  return <Section tone="navy" cta="Yes, I Want a More Structured System" data-id="element-234" data-mp="2lmiy0sqo2pbz">
      <SectionHeading title="Does Any of This Sound Familiar?" intro="If you recognize yourself in any of these situations, I created this system with your professional needs in mind." data-id="element-235" data-mp="26xegzevlyr5g" />

      <ol className="mt-12 grid gap-x-10 md:grid-cols-2" data-id="element-236" data-mp="1xwyfgayfdu38">
        {painPoints.map((p, i) => <li key={p.title} className="flex gap-4 border-t border-line py-6" data-id="element-237" data-mp="2204il9q8r55h" data-mpi={i}>
            <span className="font-serif text-4xl font-bold leading-none text-gold" data-id="element-238" data-mp="1o0d8vl6rcaxa">{i + 1}</span>
            <div data-id="element-239" data-mp="1sxv82juz3bs3">
              <h3 className="text-lg font-bold leading-snug text-cream sm:text-xl" data-id="element-240" data-mp="1szg30al78wqh">{p.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-muted" data-id="element-241" data-mp="3iemh3nz81l3t">{p.text}</p>
            </div>
          </li>)}
      </ol>

      <div className="mx-auto mt-10 max-w-2xl rounded-3xl bg-gold p-6 text-center text-ink sm:p-8" data-id="element-242" data-mp="3nalchviyw3dq">
        <p className="text-base font-semibold sm:text-lg" data-id="element-243" data-mp="1yykd1c2u3606">And this is exactly why I developed HOF CLINICAL BLUEPRINT™.</p>
        <p className="mt-3 font-serif text-2xl font-bold leading-snug sm:text-3xl" data-id="element-244" data-mp="27sqpygovatmc">
          The problem is not necessarily that you lack knowledge.
        </p>
        <p className="mt-3 text-base font-medium leading-relaxed sm:text-lg" data-id="element-245" data-mp="23s6sfc0dtnzo">
          Sometimes, the missing piece is a structured way to organize, review, and apply the knowledge you already
          have.
        </p>
      </div>
    </Section>;
}